import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index.js";
import { REFRESH } from "@/store/mutations.type";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("./components/Login.vue"),
      meta: {
        title: "Login"
      }
    },
    {
      path: "/",
      name: "dashboard",
      component: () => import("./components/Dashboard/Dashboard.vue"),
      meta: {
        title: "Dashboard"
      }
    },
    {
      path: "/advertisers",
      name: "admin_advertisers",
      component: () => import("./components/Admin/Advertisers/Advertisers.vue"),
      meta: {
        title: "Advertisers"
      }
    },
    {
      path: "/advertiser/:organization_id/:organization_name/details",
      name: "admin_advertiser_details",
      component: () => import("./components/Admin/Advertisers/AdvertiserDetails.vue"),
      meta: {
        title: "Advertiser Details"
      }
    },
    {
      path: "/advertiser/:organization_id/:organization_name/trainings",
      name: "admin_trainings",
      component: () => import("./components/Admin/Trainings/Trainings.vue"),
      meta: {
        title: "Trainings"
      }
    },
    {
      path: "/advertiser/:organization_id/:organization_name/training/:id",
      name: "admin_training_details",
      component: () => import("./components/Admin/Trainings/TrainingDetails.vue"),
      meta: {
        title: "Training Details"
      }
    },
    {
      path: "/advertiser/:organization_id/:organization_name/web_ads",
      name: "admin_web_ads",
      component: () => import("./components/Admin/WebAds/WebAds.vue"),
      meta: {
        title: "Web Ads"
      }
    },
    {
      path: "/advertiser/:organization_id/:organization_name/print_digital_ads",
      name: "admin_print_digital_ads",
      component: () => import("./components/Admin/DigitalAds/DigitalAds.vue"),
      meta: {
        title: "Print/Digital Ads"
      }
    },
    {
      path: "/advertiser/:organization_id/:organization_name/newsletter",
      name: "admin_newsletter",
      component: () => import("./components/Admin/Newsletter/Newsletter.vue"),
      meta: {
        title: "Newsletter"
      }
    },
    {
      path: "/advertiser/:organization_id/:organization_name/credit_cards",
      name: "admin_credit_cards",
      component: () => import("./components/Admin/CreditCards/CreditCards.vue"),
      meta: {
        title: "Credit Cards"
      }
    },
    {
      path: "/advertiser/:organization_id/:organization_name/reports",
      name: "admin_reports",
      component: () => import("./components/Admin/Reports/Reports.vue"),
      meta: {
        title: "Reports"
      }
    },
    {
      path: "/advertiser/:organization_id/:organization_name/product_guide",
      name: "admin_product_guide",
      component: () => import("./components/Admin/ProductGuide/ProductGuide.vue"),
      meta: {
        title: "Product Guide"
      }
    },
    {
      path: "/categories",
      name: "admin_categories",
      component: () => import("./components/Admin/Categories/Categories.vue"),
      meta: {
        title: "Categories"
      }
    },
    {
      path: "/category/:category_id/details",
      name: "admin_category_details",
      component: () => import("./components/Admin/Categories/CategoryDetails.vue"),
      meta: {
        title: "Category Details"
      }
    },
    {
      path: "/service_plans",
      name: "service_plans",
      component: () => import("./components/Admin/SubscriptionPackages/SubscriptionPackages.vue"),
      meta: {
        title: "Service Plans"
      }
    },
    {
      path: "/service_plan/:id/details",
      name: "service_plan_details",
      component: () => import("./components/Admin/SubscriptionPackages/SubscriptionPackageDetails.vue"),
      meta: {
        title: "Service Plans Details"
      }
    },
    {
      path: "/subscriptions",
      name: "subscriptions",
      component: () => import("./components/Admin/Subscriptions/Subscriptions.vue"),
      meta: {
        title: "Subscriptions"
      }
    },
    {
      path: "/subscription/:id/details",
      name: "subscription_details",
      component: () => import("./components/Admin/Subscriptions/SubscriptionDetails.vue"),
      meta: {
        title: "Subscription Details"
      }
    },
    {
      path: "/print_digital_issues",
      name: "print_digital_issues",
      component: () => import("./components/Admin/DigitalIssues/DigitalIssues.vue"),
      meta: {
        title: "Print/Digital Issues"
      }
    },
    {
      path: "/newsletters",
      name: "admin_newsletters",
      component: () => import("./components/Admin/Newsletters/Newsletters.vue"),
      meta: {
        title: "Newsletters"
      }
    },
    {
      path: "/admin_newsletter/:id/details",
      name: "admin_newsletter_details",
      component: () => import("./components/Admin/Newsletters/NewsletterDetails.vue"),
      meta: {
        title: "Newsletter Details"
      }
    },
    {
      path: "/credit_cards",
      name: "credit_cards",
      component: () => import("./components/CreditCards/CreditCards.vue"),
      meta: {
        title: "Credit cards"
      }
    },
    {
      path: "/web_ads",
      name: "web_ads",
      component: () => import("./components/WebAds/WebAds.vue"),
      meta: {
        title: "Web Ads"
      }
    },
    {
      path: "/print_digital_ads",
      name: "print_digital_ads",
      component: () => import("./components/DigitalAds/DigitalAds.vue"),
      meta: {
        title: "Print/Digital Ads"
      }
    },
    {
      path: "/newsletter",
      name: "newsletter",
      component: () => import("./components/Newsletter/Newsletter.vue"),
      meta: {
        title: "Newsletter"
      }
    },
    {
      path: "/trainings",
      name: "trainings",
      component: () => import("./components/Training/Training.vue"),
      meta: {
        title: "Trainings"
      }
    },
    {
      path: "/training/:training_id/show",
      name: "training_show",
      component: () => import("./components/Training/TrainingDetails.vue"),
      meta: {
        title: "Training Details"
      }
    },
    {
      path: "/reports",
      name: "reports",
      component: () => import("./components/Reports/Reports.vue"),
      meta: {
        title: "Reports"
      }
    },
    {
      path: "/company_profiles",
      name: "company_profiles",
      component: () => import("./components/CompanyInfo/CompanyInfo.vue"),
      meta: {
        title: "Company Profiles"
      }
    },
    {
      path: "/product_guide",
      name: "product_guide",
      component: () => import("./components/ProductGuide/ProductGuide.vue"),
      meta: {
        title: "Product Guide"
      }
    },
    {
      path: "/reset_password",
      name: "reset_password",
      component: () => import("./components/ResetPassword.vue"),
      meta: {
        title: "Reset Password"
      }
    },
    {
      path: "/reset_password/:token",
      name: "reset_password_token",
      component: () => import("./components/ResetPasswordToken.vue"),
      meta: {
        title: "Reset Password"
      }
    },
    {
      path: "/change_password",
      name: "change_password",
      component: () =>
        import("./components/ChangePassword/ChangePassword.vue"),
      meta: {
        title: "Change Password"
      }
    },
    {
      path: "/change_email",
      name: "change_email",
      component: () =>
        import("./components/ChangeEmail/ChangeEmail.vue"),
      meta: {
        title: "Change Mail"
      }
    },
    {
      path: "/no_premissions",
      name: "no_premissions",
      component: () => import("./components/NoPermissions.vue"),
      meta: {
        title: "No Permissions"
      }
    },
    {
      path: "*",
      name: "page_not_found",
      component: () => import("./components/PageNotFound.vue"),
      meta: {
        title: "Page Not Found"
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    "login",
    "reset_password",
    "reset_password_token"
  ];
  const authRequired = !publicPages.includes(to.name);
  const loggedIn = localStorage.getItem("concrete_user_token");
  const permited = store.getters.permissions.includes(to.name);
  store.commit(REFRESH);

  if (to.meta.title) {
    document.title = `${to.meta.title} | Concrete Decor`;
  } else {
    document.title = "Concrete Decor";
  }

  if (authRequired && !loggedIn) {
    next("/login");
    return;
  }

  if (!authRequired && loggedIn) {
    next("/");
    return;
  }

  if (
    !permited &&
    authRequired &&
    loggedIn &&
    to.path !== "/no_premissions" &&
    to.path !== "/"
  ) {
    if (to.name !== "page_not_found") {
      next("/no_premissions");
      return;
    }
  }

  next();
});

export default router;
